import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { AppProps } from '../../types';
import { useAddHandlersToNodes } from '../hooks/useAddHandlersToNodes';
import './SearchTakeoverRoot.scss';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

interface SearchTakeoverProps {
    domNodeId: string;
    onClose: () => void;
    id: string;
    isVisible: boolean;
}

interface SearchTakeoverControllerProps {
    isSearchTakeoverVisible: boolean | null;
    setIsSearchTakeoverVisible: (val: boolean) => void;
}

const SearchTakeoverController: React.FunctionComponent<SearchTakeoverControllerProps> = (
    props,
) => {
    const { isSearchTakeoverVisible, setIsSearchTakeoverVisible } = props;

    return (
        <>
            {isSearchTakeoverVisible !== null ? (
                <LazySearchTakeover>
                    {({
                        SearchTakeover,
                    }: {
                        SearchTakeover: FunctionComponent<SearchTakeoverProps>;
                    }) => (
                        <SearchTakeover
                            domNodeId="event-page"
                            onClose={() => setIsSearchTakeoverVisible(false)}
                            id="search-takeover"
                            isVisible={isSearchTakeoverVisible}
                        />
                    )}
                </LazySearchTakeover>
            ) : null}
        </>
    );
};

export const SearchTakeoverRoot = (props: AppProps) => {
    const [
        isSearchTakeoverVisible,
        setIsSearchTakeoverVisible,
    ] = React.useState<null | boolean>(null);

    useAddHandlersToNodes({
        callback: React.useCallback(() => {
            setIsSearchTakeoverVisible(!isSearchTakeoverVisible);
        }, [isSearchTakeoverVisible]),
        querySelector: '.search-takeover-trigger--react',
    });

    return (
        <>
            <SearchTakeoverController
                {...props}
                isSearchTakeoverVisible={isSearchTakeoverVisible}
                setIsSearchTakeoverVisible={setIsSearchTakeoverVisible}
            />
        </>
    );
};
